import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { GitCompare } from "lucide-react";

const ROWS = [
  { key: "from_display", label: "Minimum Investment", get: (c) => c.from_display },
  { key: "residency_outcome", label: "Residency Status", get: (c) => c.snapshot.residency_outcome },
  { key: "physical_presence", label: "Physical Presence", get: (c) => c.snapshot.physical_presence },
  { key: "family", label: "Family Inclusions", get: (c) => c.snapshot.family },
  { key: "tax_profile", label: "Taxation Profile", get: (c) => c.tax_profile },
  { key: "typical_pathway", label: "Processing Timeline", get: (c) => c.snapshot.typical_pathway },
  { key: "real_estate", label: "Real Estate Rights", get: (c) => c.real_estate },
];

export default function CompareView({ countries, selected, setSelected }) {
  const cols = [0, 1, 2];
  const picked = cols.map((i) => countries.find((c) => c.code === selected[i]));

  const setCol = (i, code) => {
    const next = [...selected];
    next[i] = code;
    setSelected(next);
  };

  const letters = ["a", "b", "c"];

  return (
    <div className="mx-auto max-w-lg px-4 pb-8 pt-4" data-testid="country-comparison-view">
      <h2 className="flex items-center gap-2 text-2xl font-semibold text-white">
        <GitCompare size={22} className="text-amber-300" /> Compare
      </h2>
      <p className="mt-1 text-sm text-slate-300">Assess destinations on one universal benchmark.</p>

      <div className="mt-5 grid grid-cols-3 gap-2">
        {cols.map((i) => (
          <Select key={i} value={selected[i] || ""} onValueChange={(v) => setCol(i, v)}>
            <SelectTrigger
              data-testid={`select-compare-country-${letters[i]}`}
              className="border-white/10 bg-white/5 text-xs text-slate-200"
            >
              <SelectValue placeholder="Select" />
            </SelectTrigger>
            <SelectContent className="border-white/10 bg-[#0D111A] text-slate-200">
              {countries.map((c) => (
                <SelectItem key={c.code} value={c.code} className="text-xs">
                  {c.flag} {c.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        ))}
      </div>

      {/* header flags */}
      <div className="mt-4 grid grid-cols-3 gap-2">
        {picked.map((c, i) => (
          <div key={i} className="rounded-xl border border-white/[0.07] bg-white/[0.03] p-3 text-center">
            {c ? (
              <>
                <div className="text-2xl">{c.flag}</div>
                <p className="mt-1 text-[11px] font-semibold text-white">{c.name}</p>
              </>
            ) : (
              <p className="py-3 text-[11px] text-slate-400">—</p>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 space-y-3">
        {ROWS.map((row) => (
          <div key={row.key} className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-3">
            <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.18em] text-amber-400/80">{row.label}</p>
            <div className="grid grid-cols-3 gap-2">
              {picked.map((c, i) => (
                <p key={i} className="text-[11px] leading-snug text-slate-300">
                  {c ? row.get(c) : <span className="text-slate-400">—</span>}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
